import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AdminService, ADMIN_MODULES } from "../admin.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";

@Component({
  selector: "app-admin-users-admin-add",
  templateUrl: "./admin-users-admin-add.component.html",
  styleUrls: ["./admin-users-admin-add.component.css"],
})
export class AdminUsersAdminAddComponent implements OnInit {
  AddLogin: FormGroup;
  token: any;
  file: any;
  adminModules = ADMIN_MODULES;
  selectedModules: string[] = [];
  image_link: any;
  isLoading: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private matdialogref: MatDialogRef<AdminUsersAdminAddComponent>,
    private services: AdminService,
    private snackBar: MatSnackBar,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.AddLogin = this.formBuilder.group({
      name: ["", [Validators.required, Validators.pattern('^[a-zA-Z][a-zA-Z\\s]*$')]],
      username: ["", [Validators.required, Validators.pattern('^[a-zA-Z0-9]+$')]],
      employee_id: [""],
      mobile: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{4,10}$"),
        ]),
      ],
      email: [""],
      dob: [""],
      gender: [""],
      profile_pic: [""],
      password: ["", Validators.required],
      role: ["", Validators.required],
      is_sms_enabled: [false],
    });
  }

  close() {
    this.matdialogref.close();
  }

  onChange(event: any): void {
    this.file = event.target.files[0];
    this.services.uploadImage(this.file).subscribe(
      (response: any) => {
        if (response.status === 200 || response.status === 201) {
          this.image_link = response.body.image_link;
          this.AddLogin.patchValue({
            profile_pic: this.image_link
          });
          this.snackBar.open("Image Uploaded Successfully", "Success", {
            duration: 5000,
          });
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }
  addAdmin() {
    let name = this.AddLogin.value.name;
    let user = this.AddLogin.value.username;
    let mob = this.AddLogin.value.mobile;
    let Email = this.AddLogin.value.email;
    let pass = this.AddLogin.value.password;
    let Dob = this.AddLogin.value.dob;
    let Gender = this.AddLogin.value.gender;
    let img = this.AddLogin.value.profile_pic;
    let empl = this.AddLogin.value.employee_id;
    let role = this.AddLogin.value.role;

    if (!name) {
      this.snackBar.open("Please enter name", "Fail", {
        duration: 5000,
      });
      return;
    }

    if (!user) {
      this.snackBar.open("Please Enter user name", "fail", {
        duration: 5000,
      });
      return;
    }

    if (!mob) {
      this.snackBar.open("Please enter mobile", "Fail", {
        duration: 5000,
      });
      return;
    }

    if (!Email) {
      this.snackBar.open("Please enter email ", "Fail", {
        duration: 5000,
      });
      return;
    }

    if (!pass) {
      this.snackBar.open("Please enter password ", "Fail", {
        duration: 5000,
      });
      return;
    }

    if (!Dob) {
      this.snackBar.open("Please enter dob ", "Fail", {
        duration: 5000,
      });
      return;
    }

    if (!Gender) {
      this.snackBar.open("Please enter gender ", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (!empl) {
      this.snackBar.open("Please enter employee ", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (!role) {
      this.snackBar.open("Please enter role ", "Fail", {
        duration: 5000,
      });
      return;
    }
    this.isLoading = true;
    const adminobj = {
      name: this.AddLogin.value.name,
      username: this.AddLogin.value.username,
      mobile: this.AddLogin.value.mobile,
      email: this.AddLogin.value.email,
      password: this.AddLogin.value.password,
      dob: this.AddLogin.value.dob,
      gender: this.AddLogin.value.gender,
      profile_pic: this.AddLogin.value.profile_pic,
      employee_id: this.AddLogin.value.employee_id,
      designation: this.AddLogin.value.designation,
      role: this.AddLogin.value.role,
      is_sms_enabled: this.AddLogin.value.is_sms_enabled,
      permissions: this.selectedModules,
    };
    console.log("adminobj", adminobj)
    this.services.addAdmin(adminobj, this.token).subscribe(
      (response: any) => {
        this.isLoading = false;
        if (response.status == 201) {
          this.matdialogref.close();
          this.snackBar.open("New Admin User Added", "Success", {
            duration: 5000,
          });
        }
      },
      (error) => {
        this.isLoading = false;
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  validateNumber(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    if (!/[0-9]/.test(input)) {
      event.preventDefault();
    }
  }

  validateAlphaNumeric(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    if (!/[a-zA-Z0-9]/.test(input)) {
      event.preventDefault();
    }
  }

  validateAlphabetsAndSpaces(event: KeyboardEvent) {
    const input = String.fromCharCode(event.keyCode);
    const target = event.target as HTMLInputElement;
    if (input === ' ' && target.selectionStart === 0) {
      event.preventDefault();
      return;
    }
    if (!/[a-zA-Z\s]/.test(input)) {
      event.preventDefault();
    }
  }

  toggleModule(moduleId: string) {
    const index = this.selectedModules.indexOf(moduleId);
    if (index > -1) {
      this.selectedModules.splice(index, 1);
    } else {
      this.selectedModules.push(moduleId);
    }
  }
}
